import React from "react";
import PropTypes from "prop-types";

// components
import { AppContext } from "components";
import { BaseComponent } from "shared/components";


class PictureCardComponent extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            toBeRemoved: false
        };
        this.removeProduct = this.removeProduct.bind(this);
    }
    removeProduct(name) {
        this.props.removeProduct(name);
    }

    render() {
        const { value, image } = this.props;

        return (
            <div className="container">
                <div className="card">
                    <div className="card-image">
                        <figure className="image is-3by4">
                            <img src={image} alt={value.name} />
                        </figure>
                    </div>
                    <footer className="card-footer">
                        <button className="button is-fullwidth"
                            onClick={() => {
                                this.removeProduct(value.name);
                            }}
                        >
                            <span className="icon">
                                <i className="fas fa-trash" />
                            </span>
                        </button>
                    </footer>
                </div>
            </div>
        )
    }
}

PictureCardComponent.contextType = AppContext;

PictureCardComponent.propTypes = {
    product: PropTypes.object
};

export default PictureCardComponent;
